module.exports = __webpack_public_path__ + "img/2.503388ec.svg";